import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './rootReducer';
import middlewares from './middlewares';
var initialState = {};
var middleware = composeWithDevTools(applyMiddleware.apply(void 0, [thunk].concat(_toConsumableArray(middlewares)))); // ======================================================
// Store Instantiation
// ======================================================

var store = createStore(rootReducer, initialState, middleware);
export default store;